<template lang="pug">
section.main(:class="collapsed ? 'wide' : 'narrow'")
  Header(ref="header")
  Menu
  section.page.summary(v-if="$auth.isAuthenticated && currentUser")
    h1.title
      i.icon.fas.fa-chart-bar
      span {{ page.title }}

    section.body
      b-navbar
        b-navbar-nav
          b-nav-form(inline)
            b-input-group
              b-form-select(size="sm",v-model="filters.job",:options="shouldJobs()",@change="reloadData")

            b-input-group.ml-2.mr-3
              b-form-checkbox(size="sm",switch,v-model="filters.enabledJob")
                .align-items-center
                  small 応募中のみ

            b-input-group.ml-2
              b-form-select(size="sm",v-model="filters.route",:options="options.route",@change="reloadData")
        b-navbar-nav.ml-auto
          b-nav-form(inline)
            b-input-group
              b-form-input(size="sm",v-model="filters.startDate",type="date",placeholder="年/月/日",pattern="((19|20)\d\d)[\/\-]([1-9]|0[1-9]|1[012])[\/\-]([1-9]|0[1-9]|[12][0-9]|3[01])",required,@change="reloadData")
            span.ml-2.text-secondary 〜
            b-input-group.ml-2
              b-form-input(size="sm",v-model="filters.finishDate",type="date",placeholder="年/月/日",pattern="((19|20)\d\d)[\/\-]([1-9]|0[1-9]|1[012])[\/\-]([1-9]|0[1-9]|[12][0-9]|3[01])",required,@change="reloadData")

      section.list(v-if="fields && fields.length > 0")
        b-table.data(ref="table",responsive,sticky-header,no-local-sorting,:items="data",:fields="fields",:sort-by="sort",:sort-desc="desc",@sort-changed="sortChanged")

        b-navbar.bottom
          b-navbar-nav
            b-button.mr-2(size="sm",variant="link",@click="loadData")
              i.fas.fa-sync-alt
            b-nav-text.text-muted.small {{ data.length }} 件
</template>

<script>
import { cloneDeep } from 'lodash'

import QueryHash from 'query-hash'

import { getData } from '../utils/api'

import 'dayjs/locale/ja'
import dayjs from 'dayjs'
import localizedFormat from 'dayjs/plugin/localizedFormat'

dayjs.locale('ja')
dayjs.extend(localizedFormat)

const page = {
  id: 'summary',
  title: '選考状況サマリー'
}

export default {
  // name: page.id,
  data () {
    return {
      mask: false,
      app: {
        name: process.env.VUE_APP_NAME
      },
      page: page,
      collapsed: true,
      currentUser: null,
      prepared: false,
      mode: null,
      filters: {
        job: null,
        enabledJob: false,
        route: null
      },
      options: {
        job: [],
        category: []
      },
      allCount: null,
      data: [],
      defaultFields: [
        {
          key: 'name',
          label: 'ポジション名',
          sortable: true
        }, {
          key: 'applied',
          label: '応募人数'
        }
      ],
      fields: [],
      sort: 'name',
      desc: false
    }
  },
  watch: {
    'filters.job' (val) {
      if (this.mask) { return }
      this.reloadData()
    },
    'filters.enabledJob' (val) {
      if (this.mask) { return }
      this.reloadData()
    },
    'filters.route' (val) {
      if (this.mask) { return }
      this.reloadData()
    }
  },
  methods: {
    shouldJobs () {
      this.mask = true

      let jobs = []

      if (!this.filters.enabledJob) {
        jobs = cloneDeep(this.options.job)
      } else {
        let find = false
        this.options.job.forEach((job) => {
          if (!job.value || job._enable) {
            jobs.push(job)

            if (this.filters.job && String(this.filters.job) === job.key) {
              find = true
            }
          }
        })
        /*
        if (this.filters.job && !find) {
          this.filters.job = null
        }
        */
      }

      this.mask = false

      return jobs
    },
    sortChanged (obj) {
      this.sort = obj.sortBy
      this.desc = obj.sortDesc
      this.loadData()
    },
    async prepareData () {
      this.mask = true

      if (!this.$root.currentUser || !this.$root.currentUser.role) {
        setTimeout(() => {
          this.prepareData()
        }, 300)
        return
      }

      this.$set(this, 'currentUser', this.$root.currentUser)

      this.mode = null

      this.filters.job = null
      this.filters.enabledJob = false
      this.filters.route = null

      this.options.job = [{
        value: null, text: 'すべてのポジション'
      }]

      await getData(`/jobs?sort=occupation,position&fields=name,enable&limit=-1`).then((data) => {
        for (let datum of data) {
          this.options.job.push({
            value: datum._id, text: datum.name, _enable: datum.enable
          })
        }
      }).catch((err) => {
        console.log(err)
      })

      this.options.route = [{
        value: null, text: 'すべての採用ルート'
      }]

      await getData(`/routes?sort=name&fields=name&limit=-1`).then((data) => {
        for (let datum of data) {
          this.options.route.push({
            value: datum._id, text: datum.name
          })
        }
      }).catch((err) => {
        console.log(err)
      })

      if (this.$route.query.fm) {
        this.mode = this.$route.query.fm
      }
      if (!this.mode) {
        this.mode = 'jobs'
      }

      if (this.$route.query.fj) {
        this.filters.job = this.$route.query.fj
      }
      if (this.$route.query.fej) {
        this.filters.enabledJob = this.$route.query.fej
      }
      if (this.$route.query.fr) {
        this.filters.route = this.$route.query.fr
      }

      if (this.$route.query.fds) {
        this.filters.startDate = this.$route.query.fds
      } else {
        this.filters.startDate = dayjs().subtract(14, 'days').format('YYYY-MM-DD')
      }
      if (this.$route.query.fdf) {
        this.filters.finishDate = this.$route.query.fdf
      } else {
        this.filters.finishDate = dayjs().format('YYYY-MM-DD')
      }

      this.prepared = true

      this.reloadData()
    },
    /*
    sortChanged (obj) {
      this.sort = obj.sortBy
      this.desc = obj.sortDesc
      this.reloadData()
    },
    orderChanged () {
      this.sortChanged()
    },
    */
    async reloadData () {
      this.mask = true

      this.loadData()
    },
    async loadData () {
      this.mask = true

      this.params = {}

      const query = new QueryHash()

      // query.add('limit', -1)

      query.add('mode', this.mode)
      this.params.fm = this.mode

      query.add('start', this.filters.startDate)
      this.params.fds = this.filters.startDate

      query.add('finish', this.filters.finishDate)
      this.params.fdf = this.filters.finishDate

      if (this.filters.job) {
        query.add('jobId', this.filters.job)
        this.params.fj = this.filters.job
      }

      if (this.filters.enabledJob) {
        query.add('enabledJob', this.filters.enabledJob)
        this.params.fej = true
      } else {
        delete this.params.fej
      }

      if (this.filters.route) {
        query.add('routeId', this.filters.route)
        this.params.fr = this.filters.route
      }

      let order = null
      if (this.desc) {
        order = `-${this.sort}`
      } else {
        order = this.sort
      }

      query.add('sort', order)

      this.data = []
      await getData(`/summary?${query.toQueryString()}`).then((data) => {
        if (data && data.length > 0) {
          this.data = cloneDeep(data)

          let maxSteps = 0
          for (let datum of this.data) {
            if (datum.steps && datum.steps.length > maxSteps) {
              maxSteps = datum.steps.length
            }
            if (datum.Steps && Array.isArray(datum.Steps) && datum.steps && Array.isArray(datum.steps)) {
              if (datum.Steps.length >= datum.steps.length) {
                datum.lastStep = cloneDeep(datum.Steps[datum.steps.length - 1])
              }
              if (datum.Steps.length >= datum.steps.length + 1) {
                datum.agreedStep = cloneDeep(datum.Steps[datum.steps.length])
              }
              /*
              if (datum.Steps.length >= datum.steps.length + 2) {
                datum.engagedStep = cloneDeep(datum.Steps[datum.steps.length + 1])
              }
              */
            }
            if (!datum.lastStep) {
              datum.lastStep = {
                total: 0,
                pass: 0
              }
            }
            if (!datum.lastStep.pass) {
              datum.lastStep.pass = 0
            }
            if (!datum.agreedStep) {
              datum.agreedStep = {
                total: 0,
                engage: 0
              }
            }
            if (!datum.agreedStep.engage) {
              datum.agreedStep.engage = 0
            }
            /*
            if (!datum.engagedStep) {
            }
            */
          }

          this.$data.fields = cloneDeep(this.$data.defaultFields)
          for (let i = 0; i < maxSteps; i++) {
            if (i === 0) {
              this.$data.fields.push({
                key: 'Steps[0].total',
                label: '書類選考'
              })
            } else {
              this.$data.fields.push({
                key: `Steps[${i}].total`,
                label: `${i}次選考`
              })
            }
          }
          this.$data.fields.push({
            key: 'lastStep.pass',
            label: '内定'
          })
          this.$data.fields.push({
            key: 'agreedStep.total',
            label: '内定承諾・辞退'
          })
          this.$data.fields.push({
            key: 'agreedStep.engage',
            label: '入社決定'
          })
        }
      }).catch((err) => {
        console.log(err)
      })

      this.$router.replace({ name: 'Summary', query: this.params }).catch(() => {})

      this.$forceUpdate()

      this.$refs.header.checkCondition()

      this.mask = false
    }
  }
}
</script>

<style scoped lang="stylus">
.data.table-responsive
  overflow scroll
  min-height calc(100vh - 3.75rem - 5.5rem - 3.375rem - 3.4375rem)

  >>> table
    tr.b-table-row-selected
      td
        background-color #fed
</style>
